import { useEffect, useState } from 'react'

/** The current time, re-read every `everyMs` (the "Last heartbeat Ns ago" counter counts up locally). */
export function useNow(everyMs = 1_000): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    const id = setInterval(() => {
      setNow(Date.now())
    }, everyMs)
    return () => {
      clearInterval(id)
    }
  }, [everyMs])
  return now
}
